import React, { useMemo } from 'react';
import { FieldFilterBase, FieldFilterBaseProps } from './FieldFilterBase';
import { ExpressionBuilder, ExpressionBuilderProvider, pickExpressionBuilder } from './filters/ExpressionBuilderContext';
import { FilterConfig, FilterConfigProvider, pickFilterConfig } from './filters/FilterContext';

export { FieldFilterBase, findingStateOptions } from './FieldFilterBase';

export type FieldFilterProps = FieldFilterBaseProps &
  ExpressionBuilder &
  Omit<FilterConfig, 'size'> & {
    size?: 'xSmall' | 'small' | 'medium';
  };

export const FieldFilter: React.FC<FieldFilterProps> = props => {
  const [rawConfig, rest] = pickFilterConfig(props);

  const config = useMemo<FilterConfig>(() => {
    const c: FilterConfig = {};
    if (rawConfig.size !== undefined) c.size = rawConfig.size === 'xSmall' ? 'xSmall' : 'small';
    if (rawConfig.isVertical !== undefined) c.isVertical = rawConfig.isVertical;
    if (rawConfig.disabled !== undefined) c.disabled = rawConfig.disabled;
    if (rawConfig.showAdvanced !== undefined) c.showAdvanced = rawConfig.showAdvanced;
    if (rawConfig.enableQueryObj !== undefined) c.enableQueryObj = rawConfig.enableQueryObj;
    if (rawConfig.activeProjName !== undefined) c.activeProjName = rawConfig.activeProjName;
    return c;
  }, [rawConfig]);

  const [expressionBuilder, internalProps] = pickExpressionBuilder(rest);

  return (
    <FilterConfigProvider config={config}>
      <ExpressionBuilderProvider options={expressionBuilder}>
        <FieldFilterBase {...(internalProps as FieldFilterBaseProps)} />
      </ExpressionBuilderProvider>
    </FilterConfigProvider>
  );
};
